module.exports = __webpack_public_path__ + "static/media/mono_angle.bf1011c8.png";